/* eslint-disable no-undef */
import { FunctionComponent } from 'react';
import CourseLanding from './../../components/courseLanding';
import SectionTitle from './../../components/sectionTitle';
import Quiz from './../../components/quiz';
import Component003 from './component003';
import Component004 from './component004';
import Animation008 from './animation008';
import Animation016 from './animation016';
import Animation014 from './animation014';
import Animation037 from './animation037';
import Conversation from './conversation';
import Animation011 from './animation011';
import Component005 from './component005';
import Animation024 from './animation024';
import Animation028 from './animation028';
import Component001 from './component001';
import Animation006 from './animation006';
import Animation025 from './animation025';
import Animation026 from './animation026';
import Animation038 from './animation038';
import Component002 from './component002';
import Animation039 from './animation039';
import Animation040 from './animation040';
import Animation004 from './animation004';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Animation004,
  Animation006,
  Animation008,
  Animation011,
  Animation014,
  Animation016,
  Animation024,
  Animation025,
  Animation026,
  Animation028,
  Animation037,
  Animation038,
  Animation039,
  Animation040,
  Component001,
  Component002,
  Component003,
  Component004,
  Component005,
};

export default Components;
